import React from 'react';

interface ProjectDescriptionContentProps {
    content: string;
}

/**
 * Renders project description content with special styling for ArchiPro AI generated content.
 * If the content starts with "ArchiPro Description - ", that prefix is styled in black
 * while the rest (including links) remains in the default gray color.
 */
const ProjectDescriptionContent: React.FC<ProjectDescriptionContentProps> = ({
    content,
}) => {
    const prefix = 'ArchiPro Description - ';
    const textContent = content.replace(/<[^>]*>/g, ''); // Strip HTML tags for prefix check
    const DESCRIPTION_CONTENT_STYLE =
        'font-display font-[250] [&_b]:!font-bold [&_li]:!mb-0 [&_li_p]:!mb-0 [&_ol]:list-inside [&_ol]:list-decimal [&_ol]:!leading-[100%] [&_strong]:!font-bold [&_ul]:list-inside [&_ul]:list-disc [&_ul]:!leading-[100%]';

    // If the stripped text starts with the prefix, replace the first
    // occurrence of the prefix in the original HTML with a styled span
    if (textContent.startsWith(prefix)) {
        const escPrefix = prefix.replace(/[.*+?^${}()|[\\]\\]/g, '\\$&');
        const htmlWithStyledPrefix = content.replace(
            new RegExp(escPrefix),
            `<span style="color:black">${prefix}</span>`,
        );

        // The font chosen doesn't support letters with diacritics. So when those letters fallback to a different font, they appear with a higher font weight.
        // By making the font weight to 250, those text will show up looking more similar to the rest of the text.
        return (
            <div
                className={DESCRIPTION_CONTENT_STYLE}
                dangerouslySetInnerHTML={{
                    // Override the hyperlink color to #9C9C9C and keep all original HTML
                    __html: htmlWithStyledPrefix.replace(
                        /<a\s/gi,
                        '<a style="color:#9C9C9C" ',
                    ),
                }}
            />
        );
    }

    return (
        <div
            className={DESCRIPTION_CONTENT_STYLE}
            dangerouslySetInnerHTML={{
                // Override the hyperlink color to #9C9C9C
                __html: content.replace(/<a\s/gi, '<a style="color:#9C9C9C" '),
            }}
        />
    );
};

export default ProjectDescriptionContent;
